<template lang="pug">
.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
  .match-bet-area-group.flex-grow-2
    hdpItemMMOX(:details="mmoDetails" :oddsType="oddsType" betType="hdp")
  .match-bet-area-group.flex-grow-2
    ouItemMMOX(:details="mmoDetails" :oddsType="oddsType" betType="ou")
</template>

<script>
import hdpItemMMOX from "@/components/mobile/main/xitem/hdpItemMMOX";
import ouItemMMOX from "@/components/mobile/main/xitem/ouItemMMOX";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    hdpItemMMOX,
    ouItemMMOX
  },
  mixins: [mixinHDPOUOdds]
};
</script>
